import { render, staticRenderFns } from "./SorteoEstadisticaComparativaHistorico.vue?vue&type=template&id=bb2a733c&"
import script from "./SorteoEstadisticaComparativaHistorico.vue?vue&type=script&lang=ts&"
export * from "./SorteoEstadisticaComparativaHistorico.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports